module.exports = __webpack_public_path__ + "static/media/fly0271.c58412f6.webp";